module.exports = __webpack_public_path__ + "img/bg_HAI.ce866da1.png";